import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';
import {
  TourDetailsList,
  TourOrganizer,
  TourPriceList,
} from '@/features/public/booking/components/TourInfoSections.tsx';
import { cn } from '@/lib/utils.ts';

/**
 * Kolumna o wyjeździe obok formularza — tylko od `lg` w górę. Niżej te same
 * dane rysuje `TourInfoBox`, bo pełna kolumna rozpychała ekran telefonu na
 * kilka przewinięć, zanim klient zobaczył pierwsze pole.
 */
const OrgInfo = ({
  tourBasicInfo,
  className,
  ...props
}: {
  tourBasicInfo: BookingTourBasicDataDto;
} & React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn('flex max-w-[220px] flex-col gap-5', className)}
      {...props}
    >
      <h2 className="text-xl font-semibold text-base-text">
        {tourBasicInfo.tourName}
      </h2>

      <TourOrganizer tourBasicInfo={tourBasicInfo} />

      {tourBasicInfo.prices && tourBasicInfo.prices.length > 0 && (
        <TourPriceList prices={tourBasicInfo.prices} />
      )}

      <TourDetailsList tourBasicInfo={tourBasicInfo} />
    </div>
  );
};

export default OrgInfo;
